import { Route } from '@angular/router';
import { TopbarComponent } from './topbar.component';

export const TopbarRoutes: Route[] = [
    {
      path: '',
      component: TopbarComponent
    }
  ];
